import PropTypes from 'prop-types';
import React, { useState } from 'react';
import { TooltipWrapper, TooltipContent } from './StyledComponents';

/**
 * Simple hover tooltip component for displaying helpful text on hover
 * @param {string} text - The text to display in the tooltip
 * @param {React.ReactNode} children - The element to wrap with the tooltip
 */
const Tooltip = ({ text, children }) => {
  const [showTooltip, setShowTooltip] = useState(false);

  return (
    <TooltipWrapper
      onMouseEnter={() => setShowTooltip(true)}
      onMouseLeave={() => setShowTooltip(false)}
    >
      {children}
      <TooltipContent visible={showTooltip}>{text}</TooltipContent>
    </TooltipWrapper>
  );
};

Tooltip.propTypes = {
  text: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
};

export default Tooltip;
